import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Stack,
  Button,
} from "@chakra-ui/react";

const User_list = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]); // Replace with API data
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const totalPages = Math.ceil(data.length / rowsPerPage);

  // Handle pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Filtered and paginated data
  const filteredData = data.filter((row) =>
    row.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Format Fees
  const formatFees = (fees) => {
    if (fees) {
      return `$${fees.toFixed(2)}`; // Format as currency, you can adjust this as per your needs
    }
    return "N/A"; // If no fee is available, display "N/A"
  };

  return (
    <Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        // mb={1}
        p={3}
        className="sb"
      >
        {/* Rows Per Page */}
        <Flex align="center" mb={{ base: 4, md: 0 }}>
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="120px"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </Select>
        </Flex>

        {/* Search */}
        <Flex align="center">
          <Input
            placeholder="Search by Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Flex>
      </Flex>

      {loading ? (
        <Text>Loading...</Text>
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        <Box overflowX="auto" maxWidth="100%">
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              "th, td": {
                textAlign: "center",
              },
            }}
          >
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Fees</Th>
                <Th>Contact</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((row) => (
                  <Tr key={row.id}>
                    <Td>{row.name}</Td>
                    <Td>{row.email}</Td>
                    <Td>{formatFees(row.fees)}</Td>{" "}
                    {/* Display formatted fees */}
                    <Td>{row.contact}</Td>
                    <Td>
                      <Stack direction="row" spacing={2}>
                        <Button size="sm" colorScheme="blue">
                          Edit
                        </Button>
                        <Button size="sm" colorScheme="red">
                          Delete
                        </Button>
                      </Stack>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="5" textAlign="center">
                    No users available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      )}

      {/* Pagination Controls */}
      <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages && (
            <>
              {currentPage < totalPages - 1 && <Text>...</Text>}
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default User_list;
